import { API_BASE_URL } from "config/api.js";
// const API_BASE_URL = "https://aktiennewsreader.azurewebsites.net";
// const API_BASE_URL = "https://localhost:7140";
// const API = "/api";

async function jsonOrThrow(resp) {
    if (!resp.ok) {
        const text = await resp.text();
        throw new Error(`API ${resp.status}: ${text}`);
    }
    return resp.json();
}

export const getNewsList = (count = 50) =>
    fetch(`${API_BASE_URL}/api/news/list?count=${count}`).then(jsonOrThrow);

export const getNewsDetail = (id) =>
    fetch(`${API_BASE_URL}/api/news/detail/${id}`).then(jsonOrThrow);

export const getSignals = (count = 10) =>
    fetch(`${API_BASE_URL}/api/news/signals?count=${count}`).then(jsonOrThrow);

export const getStats = () =>
    fetch(`${API_BASE_URL}/api/news/stats`).then(jsonOrThrow);

export const getPrice = (symbol) =>
    fetch(`${API_BASE_URL}/api/prices/${encodeURIComponent(symbol)}`).then(jsonOrThrow);

export async function getNewsByDate(
    date,
    endDate = null,
    actions = [],
    q = "",
    page = 1,
    pageSize = 15
) {
    const params = new URLSearchParams();

    params.set("date", date);

    if (endDate && endDate !== date) {
        params.set("endDate", endDate);
    }

    if (actions.length > 0) {
        params.set("actions", actions.join(","));
    }

    if (q && q.trim().length > 0) {
        params.set("q", q.trim());
    }

    params.set("page", String(page));
    params.set("pageSize", String(pageSize));

    const res = await fetch(`${API_BASE_URL}/api/news/by-date?${params.toString()}`);
    return jsonOrThrow(res);
}

export async function getAlertsBySymbolAndDate(symbol, date) {
    const normalized =
        symbol && /^[A-Z0-9.-]+$/.test(String(symbol).trim().toUpperCase())
            ? String(symbol).trim().toUpperCase()
            : null;

    if (!normalized || normalized.length < 3 || !date) {
        return { items: [] };
    }

    const params = new URLSearchParams();
    params.set("symbol", normalized);
    params.set("date", date);

    const res = await fetch(`${API_BASE_URL}/api/alerts?${params.toString()}`);
    return jsonOrThrow(res);
}

export async function getAlertSummaryBySymbolsAndDate(symbols = [], date) {
    if (!symbols || symbols.length === 0 || !date) {
        return { items: [] };
    }

    const uniqueSymbols = [
        ...new Set(
            symbols
                .filter(Boolean)
                .map((s) => String(s).trim().toUpperCase())
                .filter((s) => /^[A-Z0-9.-]+$/.test(s) && s.length >= 3)
        ),
    ];

    if (uniqueSymbols.length === 0) {
        return { items: [] };
    }

    const params = new URLSearchParams();
    params.set("date", date);
    params.set("symbols", uniqueSymbols.join(","));

    const res = await fetch(`${API_BASE_URL}/api/alerts/summary?${params.toString()}`);
    return jsonOrThrow(res);
}